<template>
    <div class="aba-cliente">
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="vertical-flow">
            <div class="columns">
                <div
                    class="column"
                    :class="[
                        permissaoVincular && permissaoCadastrar
                            ? 'is-4'
                            : permissaoVincular || permissaoCadastrar ? 'is-6' : 'is-8',
                    ]"
                >
                    <search-bar
                        :onSearch="debouncedOnSearch"
                        tooltipLabel="msg-campo-busca-prazo-pagamento"
                    />
                </div>
                <div
                    class="column"
                    :class="[
                        permissaoVincular && permissaoCadastrar
                            ? 'is-2'
                            : permissaoVincular || permissaoCadastrar ? 'is-3' : 'is-4',
                    ]"
                >
                    <vss-select
                        ref="situacaoSelect"
                        :searchable="false"
                        :options="situacaoSelect"
                        v-model="situacaoSelected"
                        mlLabels
                        title="situacao"
                        clearable
                        @input="onSituacaoChanged"
                        :height="40"
                    />
                </div>
                <div class="column is-3" v-if="permissaoVincular">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="showModal = !showModal"
                    >
                        {{ $t("vincular-prazo-pagamento") }}
                    </button>
                </div>
                <div class="column is-3" v-if="permissaoCadastrar">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="showModalCadastroPrazoPagamento"
                    >
                        {{ $t("adicionar-prazo-pagamento") }}
                    </button>
                </div>

            </div>
            <div class="registry-wrapper">
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="assprazopagtoclientelist"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.key) : ''"
                        :width="f.width"
                        :class="{
                            'excluir-field': f.key == 'excluir'
                        }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'excluir'">
                            <b-button
                                v-if="permissao.update && !assPrazoPagtoClienteIntegracao"
                                class="action-button"
                                :type="props.row['replicapda']==3?'is-danger':'is-success'"
                                :icon-right="props.row['replicapda']==3?'delete':'check'"
                                @click="promptChangeSituacao(props.row)"
                                v-tippy 
                                :title="$t(props.row['replicapda']==3?'desativar':'reativar')"
                            />
                        </div>
                        <div v-else-if="f.key == 'data-hora'">
                            {{ props.row[f.key] | moment('DD/MM/YYYY HH:mm:ss') }}
                        </div>
                        <div v-else-if="f.key == 'replicapda'">
                            <b-tag 
                                class="table-tag table-tag-full-width" 
                                :type="props.row['replicapda']==3?'is-success':'is-danger'" 
                                size="is-medium"
                            >
                                {{$t(props.row['replicapda']==3?'ativo':'inativo')}}
                            </b-tag>
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>
            <!-- MODAL DE ASSOCIACAO -->
            <b-modal :active.sync="showModal" @close="fecharModal">
                <div class="bg">
                    <PrazoPagamentoModal 
                        :idCliente="$route.params.id" 
                        @fecharModal="fecharModal"/>
                </div>
            </b-modal>
            <!-- MODAL DE CADASTRO PRAZO DE PAGAMENTO -->
            <b-modal :active.sync="modalCadastroPrazoPagamento">
                <div>
                    <PrazoPagamentoCadastroModal 
                    @fecharModal="fecharModal" 
                    @cadastrado="cadastrado" 
                    :permissaoVincular="!assPrazoPagtoClienteIntegracao"
                    :idCliente="$route.params.id"/>
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
// SERVICES
import AssPrazoPagamentoCliente from '@/services/vendas/cliente/abas/AssPrazoPagamentoClienteService';
import PrazoPagamentoModal from '@/components/vendas/cliente/modal/PrazoPagamentoModal.vue';
import PrazoPagamentoCadastroModal from '@/components/vendas/cliente/modal/PrazoPagamentoCadastroModal.vue';

// COMPONENTS
import ContainerLoader from "@/components/content/loader/ContainerLoader";

/* @70957 */
export default {
    components: {
        ContainerLoader,
        PrazoPagamentoModal,
        PrazoPagamentoCadastroModal
    },
    data() {
        return {
            assPrazoPagtoClienteIntegracao: this.$store.state.user.tabelasERPWebServer.includes("ASSPRAZOPAGTOCLIENTE"),
            prazoPagtoIntegracao: this.$store.state.user.tabelasERPWebServer.includes("PRAZOPAGTO"),
            assprazopagtoclientelist: [],
            fields: [
                { key: 'codigo', width: null, sortable: true, sortFn: null },
                { key: 'prazo-pagamento', width: null, sortable: true, sortFn: null },
                { key: 'replicapda', width: 80, sortable: true, sortFn: null},
                { key: 'excluir', width: 20, sortable: false, sortFn: null}
            ],
            service: new AssPrazoPagamentoCliente(this.$http, this.$router),
            permissao: false,
            permissaoCadastroPrazoPagamento: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            situacaoSelected: { id: 4, label: "todos" },
            situacaoSelect: [
                { id: 4, label: "todos" },
                { id: 3, label: "ativos" },
                { id: 2, label: "inativos" },
            ],
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: '',
            column: 'prazo-pagamento',
            order: 'asc',
            delete: null,
            showModal: false,
            modalCadastroPrazoPagamento: false,
            assprazopagtocliente: null,

            //permissoes relativas à exibição dos botões
            permissaoVincular: false,
            permissaoCadastrar: false,

            isVenda: this.$route.meta.contexto == "vendas",
            isAgro: this.$route.meta.contexto == "agro",
        }
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[
            this.pagination.optionStarted
        ];

        if (this.isVenda) {
            this.permissao = this.hasPermissionAccess(
                "vendas",
                "clientes",
                "ven-cliente-politica-comercial-prazo-pagamento"
            );
            this.permissaoCadastroPrazoPagamento = this.hasPermissionAccess(
                "vendas",
                "clientes",
                "ven-prazo-pagamento"
            );
        }else if (this.isAgro) {
            this.abrev = this.$route.meta.contexto.slice(0,4);
            this.permissao = this.hasPermissionAccess( 
                'agro', 
                'clientes', 
                'agro-cliente-politica-comercial-prazo-pagamento'
            );
            this.permissaoCadastroPrazoPagamento = this.hasPermissionAccess( 
                'agro', 
                'clientes', 
                'agro-prazo-pagamento'
            );
        }

        this.permissaoVincular = this.permissao.create && !this.assPrazoPagtoClienteIntegracao;
        this.permissaoCadastrar = this.permissaoCadastroPrazoPagamento.create && !this.prazoPagtoIntegracao;
        
        if (!this.permissao.read){
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'clientes' },
            });
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados();
        }
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            this.findAll(
                this.column,
                this.order,
                currentPage - 1,
                this.pagination.perPage,
                this.situacaoSelected.id,
                this.$route.params.id,
                this.queryFilter
            )
            .then(this.mapItems)
            .then(value => {
                this.assprazopagtoclientelist = value;
                this.isEmpty = this.assprazopagtoclientelist.length <= 0;
            })
            .catch(e => {
                this.isEmpty = true;
                this.$root.showMessage('error', 'msg-erro-load');
                console.error('Erro ao carregar as tabelas de prazo de pagamento.');
            })
            .finally(_ => {
                this.isLoading = false;
                this.pagination.resetPagination = false;
            });
        },
        findAll(column, order, page, limit, situacao, idcliente, ...params) {
            if(this.isVenda) {
                return this.service
                .findAllVendas(column, order, page, limit, situacao, idcliente, ...params);
            }else {
                return this.service
                .findAllAgro(column, order, page, limit, situacao, idcliente, ...params);
            }
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map(m => {
                return {
                    idassprazopagtocliente: m.idassprazopagtocliente,
                    codigo: m.prazopagto.idprazopagtoerp,
                    idprazopagto: m.prazopagto.idprazopagto, 
                    'prazo-pagamento': m.prazopagto.descricao,
                    'data-hora': m.datahorainc,
                    replicapda: m.replicapda,
                    idassprazopagto: m.idassprazopagtocliente, 
                    idcliente: m.idcliente,
                    prazopagto: m.prazopagto,
                };
            });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSituacaoChanged(val) {
            this.situacaoSelected = val ? 
                this.situacaoSelect.filter(v => v.id == val.id)[0] : 
                this.situacaoSelect[0];
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.situacao==3
                        ?'msg-confirmacao-desativacao-n'
                        :'msg-confirmacao-reativacao-n', 
                    { n: row['prazo-pagamento'] }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.replicapda == 3
                    ? 'msg-erro-ao-reativar-associacao-prazo-pagamento'
                    : 'msg-erro-ao-desativar-associacao-prazo-pagamento';

            let tempAssprazopagtocliente = {
                idassprazopagtocliente: this.delete.idassprazopagtocliente,
                replicapda: this.delete.replicapda == 3 ? 2 : 3
            }

            this.isLoading = true;

            this.updateSituacao(tempAssprazopagtocliente)
            .then(r => {
                if(r.status == 200){
                    let tempSuccess =
                        r.content.replicapda == 3
                            ? 'msg-sucesso-ao-reativar-associacao-prazo-pagamento'
                            : 'msg-sucesso-ao-desativar-associacao-prazo-pagamento';
                    this.$root.showMessage('success', tempSuccess);
                    this.carregarDados(this.pagination.currentPage);
                } else if (r.status == 500){
                    this.$root.showMessage('error', 'Erro ao atualizar status.');
                }
            })
            .catch(e => {
                console.error('Erro ao atualizar status.', e);
                this.$root.showMessage('error', tempFailure);
            })
            .finally(_ => {
                this.isLoading = false;
                this.delete = null;
            });
        },
        updateSituacao(assprazopagtocliente) {
            if(this.isVenda) return this.service.updateSituacaoVendas(assprazopagtocliente);
            else return this.service.updateSituacaoAgro(assprazopagtocliente);
        },
        showModalCadastroPrazoPagamento() {
            this.modalCadastroPrazoPagamento = !this.modalCadastroPrazoPagamento;
        },
        fecharModal() {
            this.modalCadastroPrazoPagamento = false;
            this.showModal = false;
            this.carregarDados();
        },
        cadastrado() {
            this.modalCadastroPrazoPagamento = false;
            this.carregarDados();
            this.$root.showMessage('success', 'msg-sucesso-ao-adicionar-associacao');
        }
    },
}
</script>

<style lang="scss" scoped>
.aba-cliente {
    height: 100%;
    
    .botao-acao{
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .search-bar {
            padding-bottom: 0.40rem;
        }
        .botao-acao{
            margin-top: 0;
        }
    }
}
</style>
